// Utility to resolve a display string for a credit card from a transaction row
// Supports multiple backend response shapes and uses a provided cardMap (Map of id->card)
// Returns a string like "Lender *1234" or just "Lender"; falls back to "Unknown Lender" if necessary.

function normalizeId(val) {
  if (val == null) return null;
  // Accept numbers or strings; ignore objects
  if (typeof val === 'number' || typeof val === 'string') return String(val);
  return null;
}

function getLast4From(obj) {
  if (!obj) return null;
  if (obj.last_four_digits_of_card != null) return String(obj.last_four_digits_of_card);
  if (obj.account_number) return String(obj.account_number).slice(-4);
  if (obj.card_last4 != null) return String(obj.card_last4);
  return null;
}

function resolveCardDisplay(transaction, cardMap) {
  try {
    let lender;
    let last4 = null;
    let revolverId = null;

    // Handle various shapes: revolver as object, primitive id, or alternate fields
    const rev = transaction && transaction.revolver;

    if (rev && typeof rev === 'object') {
      // Embedded object
      if (rev.id != null) revolverId = String(rev.id);
      // Prefer embedded lender/last4 first
      if (rev.lender) lender = rev.lender;
      const embeddedLast4 = getLast4From(rev);
      if (embeddedLast4 != null) last4 = embeddedLast4;
    } else if (rev != null) {
      // Primitive FK id
      revolverId = normalizeId(rev);
    }

    // Additional common backend fields
    // e.g., transaction.revolver_id or transaction.credit_card_id
    if (!revolverId) {
      revolverId = normalizeId(
        transaction?.revolver_id ?? transaction?.credit_card_id ?? transaction?.card_id
      );
    }

    // Look up in cardMap for authoritative data
    if (revolverId && cardMap && typeof cardMap.get === 'function') {
      const card = cardMap.get(String(revolverId));
      if (card) {
        if (!lender && card.lender) lender = card.lender;
        const mapLast4 = getLast4From(card);
        if (mapLast4 != null && last4 == null) last4 = mapLast4;
      }
    }

    // Loose fallbacks from flat transaction fields
    if (!lender) lender = transaction?.revolver_lender || transaction?.card_lender || transaction?.lender;
    if (last4 == null) {
      const altLast4 = transaction?.last_four_digits_of_card ?? transaction?.card_last4 ?? transaction?.last4;
      if (altLast4 != null) last4 = String(altLast4);
    }

    // Final fallback
    if (!lender) lender = 'Unknown Lender';

    return last4 ? `${lender} *${last4}` : lender;
  } catch (e) {
    return 'Unknown Lender';
  }
}

export default resolveCardDisplay;
